<template>
    <full-container>
        <div class="content-center">
            <div class="content-constraint py-10">
                <h1 class="sr-only">Languages</h1>
                <div>
                    If you, or someone you’re helping, needs assistance, you
                    have the right to get help and information in your language
                    at no cost. To talk to an interpreter, call the Customer
                    Service number on the back of your card, or {{ siteConfig.customerContactPhone }},
                    TTY: {{ utilityNavContactPhoneTty }} if you are not already a member.
                </div>
                <h2 id="es">(Spanish) <span lang="es">Español</span></h2>
                <div lang="es">
                    Si usted, o alguien a quien está ayudando, necesita ayuda,
                    tiene derecho a recibir ayuda e información en su idioma sin
                    costo alguno. Para hablar con un intérprete, llame al
                    {{ customerContactPhone }}, TTY: {{ utilityNavContactPhoneTty }} si aún no es miembro.
                </div>
                <h2 id="fr">(French) <span lang="fr">Français</span></h2>
                <div lang="fr">
                    Si vous ou quelqu'un que vous aidez avez besoin d'aide, vous
                    avez le droit d'obtenir gratuitement de l'aide et des
                    informations dans votre langue. Pour parler à un interprète,
                    composez le {{ customerContactPhone }}, TTY: {{ utilityNavContactPhoneTty }} si vous n'êtes pas déjà
                    membre.
                </div>
                <h2 id="ar">(Arabic) <span lang="ar">العَرَبِيَّة</span></h2>
                <div lang="ar">
                    {{ customerContactPhone }} إذا كنت أنت أو أي شخص تساعده بحاجة إلى
                    المساعدة ، فيحق لك الحصول على المساعدة والمعلومات بلغتك دون
                    أي تكلفة. للتحدث إلى مترجم فوري ، اتصل بالرقم ، TTY: {{ utilityNavContactPhoneTty }} إذا
                    لم تكن عضوًا بالفعل.
                </div>
                <h2 id="z-Hant">
                    (Chinese) <span lang="zh-Hant">繁體中文</span>
                </h2>
                <div lang="zh-Hant">
                    中文
                    如果您或您正在帮助的人需要帮助，您有权免费获得使用您的语言的帮助和信息。要与口译员交谈，请致电1-800-241-2567，TTY：{{ utilityNavContactPhoneTty }}（如果您还不是会员）。
                </div>
                <h2 id="ve">(Vietnamese) <span lang="ve">Tiếng Việt</span></h2>
                <div lang="ve">
                    Nếu bạn, hoặc người bạn đang giúp đỡ, cần giúp đỡ, bạn sẽ có
                    quyền trợ giúp và biết thêm thông tin bằng ngôn ngữ của bạn
                    miễn phí. Để nói chuyện với một cuộc gọi thông dịch viên
                    hoặc {{ customerContactPhone }}, TTY: {{ utilityNavContactPhoneTty }} nếu bạn chưa phải là hội viên.
                </div>
                <h2 id="sq">(Albanian) <span lang="sq">Shqiptar</span></h2>
                <div lang="sq">
                    Nëse ju, ose dikush që po ndihmoni, keni nevojë për ndihmë,
                    ju keni të drejtë të merrni ndihmë dhe informacion në gjuhën
                    tuaj pa ndonjë kosto. Për të biseduar me një përkthyes,
                    telefononi {{ customerContactPhone }}, TTY: {{ utilityNavContactPhoneTty }} nëse nuk jeni tashmë
                    anëtar.
                </div>
                <h2 id="ko">(Korean) <span lang="ko">한국어</span></h2>
                <div lang="ko">
                    귀하 또는 귀하가 돕고있는 사람에게 도움이 필요한 경우 귀하는
                    무료로 귀하의 언어로 도움과 정보를받을 권리가 있습니다.
                    통역사와 통화하려면 {{ customerContactPhone }}, TTY : {{ utilityNavContactPhoneTty }}로
                    전화하십시오.
                </div>
                <h2 id="ne">(Nepali) <span lang="ne">नेपाली</span></h2>
                <div lang="ne">
                    यदि तपाईं वा कोही मद्दत गर्दै हुनुहुन्छ भने सहयोग आवश्यक छ,
                    तपाईंसँग बिना कुनै मूल्यको तपाईंको भाषामा मद्दत र जानकारी
                    प्राप्त गर्ने अधिकार छ। दोभाषेसँग कुरा गर्न {{ customerContactPhone }}
                    call, TTY: {{ utilityNavContactPhoneTty }} यदि तपाईं पहिल्यै सदस्य हुनुहुन्न भने।
                </div>
                <h2 id="pl">(Polish) <span lang="pl">Polskie</span></h2>
                <div lang="pl">
                    Jeśli Ty lub ktoś, komu pomagasz, potrzebujesz pomocy, masz
                    prawo do bezpłatnego uzyskania pomocy i informacji w swoim
                    języku. Aby porozmawiać z tłumaczem, zadzwoń pod numer
                    {{ customerContactPhone }}, TTY: {{ utilityNavContactPhoneTty }}, jeśli nie jesteś jeszcze
                    członkiem.
                </div>
                <h2 id="de">(German) <span lang="de">Deutsch</span></h2>
                <div lang="de">
                    Wenn Sie oder jemand, dem Sie helfen, Unterstützung
                    benötigen, haben Sie das Recht, kostenlos Hilfe und
                    Informationen in Ihrer Sprache zu erhalten. Um mit einem
                    Dolmetscher zu sprechen, rufen Sie {{ customerContactPhone }}, TTY: {{ utilityNavContactPhoneTty }}
                    an, wenn Sie noch kein Mitglied sind.
                </div>
                <h2 id="it">(Italian) <span lang="it">Italian</span></h2>
                <div lang="it">
                    Se tu o qualcuno che stai aiutando ha bisogno di assistenza,
                    hai il diritto di ottenere aiuto e informazioni nella tua
                    lingua senza alcun costo. Per parlare con un interprete
                    chiama il numero {{ customerContactPhone }}, TTY: {{ utilityNavContactPhoneTty }} se non sei già un
                    membro.
                </div>
                <h2 id="ja">(Japanese) <span lang="ja">日本語</span></h2>
                <div lang="ja">
                    あなたまたはあなたが支援している誰かが支援を必要とする場合、あなたは無料であなたの言語で支援と情報を得る権利があります。インタープリターと通話するには、{{ customerContactPhone }}、TTY：まだメンバーでない場合は{{ utilityNavContactPhoneTty }}に電話してください。
                </div>
                <h2 id="ru">(Russian) <span lang="ru">Русский</span></h2>
                <div lang="ru">
                    Если вам или кому-то, кому вы помогаете, нужна помощь, вы
                    имеете право получить помощь и информацию на вашем языке
                    бесплатно. Чтобы поговорить с переводчиком, позвоните по
                    телефону {{ customerContactPhone }}, TTY: {{ utilityNavContactPhoneTty }}, если вы еще не являетесь
                    участником.
                </div>
                <h2 id="bs">(Bosnian) <span lang="bs">Bosanski</span></h2>
                <div lang="bs">
                    Ako vam je potrebna pomoć ili nekome kome pomažete, imate
                    pravo na besplatnu pomoć i informacije na svom jeziku. Da
                    biste razgovarali sa prevodiocem, nazovite {{ customerContactPhone }},
                    ako niste već član.
                </div>
                <h2 id="tl">
                    (Tagalog - Filipino) <span lang="tl">Tagalog</span>
                </h2>
                <div lang="tl">
                    Kung ikaw, o isang taong tinutulungan mo, ay nangangailangan
                    ng tulong, may karapatan kang humingi ng tulong at
                    impormasyon sa iyong wika nang walang gastos. Upang makausap
                    ang isang tagapagsalin na tumawag sa {{ customerContactPhone }}, TTY:
                    {{ utilityNavContactPhoneTty }} kung hindi ka pa miyembro.
                </div>
            </div>
        </div>
    </full-container>
</template>

<script>
import { mapState } from 'vuex'
import FullContainer from '@/containers/full-container'
export default {
  name: 'Languages',
  components: {
    FullContainer
  },
  computed: {
    ...mapState('site', ['siteConfig']),
    customerContactPhone () {
      if (!this.siteConfig || !this.siteConfig.customerContactPhone) return ''
      return this.siteConfig.customerContactPhone
    },
    utilityNavContactPhoneTty () {
      if (!this.siteConfig || !this.siteConfig.utilityNavContactPhoneTty) return ''
      return this.siteConfig.utilityNavContactPhoneTty
    }
  },
  mounted () {
    if (this.$route.params.lang) {
      this.$scrollTo(document.getElementById(this.$route.params.lang))
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
    font-weight: bolder !important;
    font-size: 16px !important;
    color: #333 !important;
    margin-top: 20px;
}

div {
    font-size: 16px !important;
}
</style>
